// --- Logic --------------------------------------------------------------------------------------

/** Mirrors `SLUG_REGEX` in the backend — keep the two in step or the form will accept what the API rejects. */
const SLUG_REGEX = /^[a-z][a-z0-9-]{1,28}[a-z0-9]$/;

const SLUG_MAX_LENGTH = 30;

/**
 * Cleans a slug field as it is typed. A slug becomes a live subdomain and ends up printed on a QR
 * code, so anything that is not URL-safe never makes it into the field in the first place — it is
 * far kinder than accepting Arabic or `@` and rejecting it on submit.
 *
 * A trailing dash survives here even though it is invalid on its own: the user is still mid-word.
 */
export const sanitizeSlugInput = (value: string): string =>
    value
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "")
        .replace(/^[^a-z]+/, "")
        .slice(0, SLUG_MAX_LENGTH);

/** The full rule, for submit time: starts with a letter, ends alphanumeric, 3–30 characters. */
export const isValidSlug = (value: string): boolean => SLUG_REGEX.test(value.trim());
